// Shared allowlists for the Shipshopy external-user access to Delivery Center Orders.
// Mirrors the backend constants of the same names in manijment-api/services/orderService.js —
// must stay in sync (same dual-allowlist gotcha as DISPOSITION_EDIT_USERS/RAD_EDIT_USERS, see
// .claude/memory/project_delivery_center_orders_tab.md).

// Shipshopy (external courier partner) — restricted to only this one page across the whole CRM.
export const DELIVERY_CENTER_EXTERNAL_USERS = ["8527921011", "7982460281"];

// Internal SCM team — Kajal, Sheetal, Bhavna, Harshit Singh, Amisha, Vardan, Kunal. Same
// roster as SCM_TEAM_PHONE_NUMBERS in orderService.js.
export const SCM_TEAM_PHONE_NUMBERS = ["7048952168", "9315481432", "7011576531", "9811068834", "9310278575", "9625766488", "8882083014", "8076818878"];
